export default __webpack_public_path__ + "static/media/Savage Death Bracers.fb6c757f.jpg";